import { Injectable } from '@angular/core';

@Injectable()
export class GlobalsService {

  constructor() { }

  public multiExpandAlerts: Boolean = false;

  public highPriority = true;
  public lowPriority = true;
  public volumeType = true;
  public timingType = true;
  public staffType = true;
  public environmentalType = true;
  public detailsSelected = 2;
  public newestFirst = 0;

  public reset() {
    this.detailsSelected = 2;
    this.volumeType = true;
    this.environmentalType = true;
    this.highPriority = true;
    this.lowPriority = true;
    this.staffType = true;
    this.timingType = true;
    this.volumeType = true;
    this.multiExpandAlerts = false;
    this.newestFirst = 0;
  }

  public resetFilters() {
    this.volumeType = true;
    this.environmentalType = true;
    this.highPriority = true;
    this.lowPriority = true;
    this.staffType = true;
    this.timingType = true;
    this.volumeType = true;
  }
}



// WEBPACK FOOTER //
// /Users/charles/Documents/AState-Senior/HCI/proj/amd2/src/app/globals.service.ts